import angular from 'angular';

import component from './automation-select.component';

const AutomationSelect = angular
    .module('control-room.experience-promoter.components.experience-manage.components.automation-select', [])
    .component('crAutomationSelect', component);

export default AutomationSelect;
